module.exports = __webpack_public_path__ + "static/media/3.f2303ab1.jpg";